import {Row, Col} from 'antd';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import {useIntl} from 'react-intl';
import FormItem from '../../../../../../../../shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IOptionModalLanguageProps {
  code: string;
}

const OptionModalLanguage = (props: IOptionModalLanguageProps) => {
  const {code} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages[
              'specificationAttributes.edit.option.name'
            ].toString()}
            titleTooltip={messages[
              'tooltip.specificationAttributes.edit.option.name'
            ].toString()}
            isTooltip
            fieldCommponent={
              <Input
                name='name'
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default OptionModalLanguage;
